/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

filtersAccordionStyles.accordion = {
    css: css`
        .accordionSectionsWrapper {
            background: ${getColor("common.background")};
            border: 1px solid ${getColor("common.ui12")};
            border-top: 0;
            overflow: hidden;
            padding: 0 15px 15px;
            position: relative;

            &:last-child {
                border-radius: 0 0 6px 6px;
            }
        }

        .scrollable {
            &:after {
                content: " ";
                height: 23px;
                position: absolute;
                bottom: 15px;
                left: 15px;
                right: 23px;
                background: linear-gradient(
                    180deg,
                    rgba(255, 255, 255, 0) 0%,
                    ${getColor("common.background")} 74.87%,
                    ${getColor("common.background")} 100%
                );
            }
        }
    `,
};
